import React, {useEffect} from 'react';
import {Button} from 'semantic-ui-react';
import {ClipIcon} from './clipIcon';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';

const ButtonFloatClientFiles = ({
  openModalInventoryFiles,
  code,
  fileType,
  title,
  className,
  setDisableModalInventoryFiles,
  disabled,
}) => {
  useEffect(() => {
    setDisableModalInventoryFiles(!!disabled);
  }, []);
  
  return (
    <Button
      icon
      className={`upload-float-file ${className}`}
      type='button'
      color='blue'
      title={title}
      onClick={() =>
        openModalInventoryFiles({
          'fileType': fileType,
          'id': code,
        })
      }>
      <ClipIcon />
    </Button>
  );
};

const {openModalInventoryFiles, setDisableModalInventoryFiles} = Actions;

export default connect(null, {
  openModalInventoryFiles,
  setDisableModalInventoryFiles,
})(ButtonFloatClientFiles);
